module.exports = __webpack_public_path__ + "img/visa-classic.c2a4ac6d.svg";